import { render, staticRenderFns } from "./miBindPhone.vue?vue&type=template&id=8b04d7d4&scoped=true&"
import script from "./miBindPhone.vue?vue&type=script&lang=js&"
export * from "./miBindPhone.vue?vue&type=script&lang=js&"
import style0 from "./miBindPhone.vue?vue&type=style&index=0&id=8b04d7d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b04d7d4",
  null
  
)

export default component.exports